import { useQuery } from '@tanstack/react-query';
import { getConnector } from './connectorsApi';

export const useGetConnectorHandler = (connectorKey) => {
  const query = useQuery({
    queryKey: ['connector', connectorKey],
    queryFn: () => getConnector(connectorKey),
    enabled: Boolean(connectorKey),
  });

  return {
    connector: query.data,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
};
